import React from 'react';
import './Schedule.css'

const Schedule = ({ 
  schedules, 
  teacherId, 
  selectedEvent, 
  courseId, 
  scheduleClickHandler, 
  scheduleBookningId,
  minStartTime,
  maxEndTime,
}) => {

  const identifyDoubleBookings = (schedules) => {
    const doubleBooked = {};
    schedules.forEach((booking1, index) => {
      schedules.slice(index + 1).forEach(booking2 => {
        if (
          booking1.startTid < booking2.slutTid &&
          booking2.startTid < booking1.slutTid
        ) {
          if (!doubleBooked[booking1.bokningsId]) {
            doubleBooked[booking1.bokningsId] = 'first';
          }
          doubleBooked[booking2.bokningsId] = 'second';
        }
      });
    });
  
    return doubleBooked;
  };
  
  const calculateWidth = (booking) => {
    const workDayStart = convertToMinutes(minStartTime());
    const workDayEnd = convertToMinutes(maxEndTime());
    const workDayMinutes = workDayEnd - workDayStart;
    const startMinutes = convertToMinutes(booking.startTid);
    const endMinutes = convertToMinutes(booking.slutTid);
    let widthPercentage = ((endMinutes - startMinutes) / workDayMinutes) * 100;
    widthPercentage = Math.min(widthPercentage, 100);
    return widthPercentage;
  };

  const calculateLeftPosition = (booking) => {
    const workDayStart = convertToMinutes(minStartTime());
    const workDayMinutes = convertToMinutes(maxEndTime()) - workDayStart;
    const startMinutes = convertToMinutes(booking.startTid);
    let leftPercentage = ((startMinutes - workDayStart) / workDayMinutes) * 100;
    leftPercentage = Math.max(leftPercentage, 0);
    return leftPercentage;
  };

  const convertToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  return (
  <div className="scdual-container">
      {schedules?.map((booking) => {
        const doubleBookingStatus = identifyDoubleBookings(schedules)[booking.bokningsId];
        let topPosition = '15%'; // default position
        let height = '70%'; // default height

        if (doubleBookingStatus === 'first') {
          topPosition = '10%';
          height = '35%';
        } else if (doubleBookingStatus === 'second') {
          topPosition = '53%';
          height = '35%';
        }

        return (
          <div
           onClick={() => scheduleClickHandler(teacherId, booking.bokningsId)}
            key={booking.bokningsId}
            className="time-block"
            title={booking.startTime}
            style={{
              width: `${calculateWidth(booking)}%`,
              left: `${calculateLeftPosition(booking)}%`,
              top: topPosition,
              height: height,
              backgroundColor:
              booking.bokningsId === courseId ? '#CD853F' : '#34495E',
              border: teacherId === selectedEvent && booking.bokningsId === scheduleBookningId && !courseId ? '2px solid #CD853F' : '',
            }}
          ></div>
        );
      })}
    </div>
  );
}

export default Schedule;
